import { createHashRouter, createBrowserRouter } from "react-router";

import { hubConstants, viewPathConstants } from "../constants";

// Inside Hub the host page owns the URL path, so routes live in the URL hash.
export const createAppRouter = (element) => {
  const routes = [{ path: viewPathConstants.ALL_ROUTES, element }];
  const isEmbeddedInHub = document.getElementById(
    hubConstants.HUB_ROOT_ELEMENT_ID
  );

  return isEmbeddedInHub
    ? createHashRouter(routes)
    : createBrowserRouter(routes);
};
